import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export const InfoIcon = ({ title = 'Info', ...props }: CreateIconComponentProps): JSX.Element => (
  <CreateIconComponent title={title} viewBox="0 0 72 72" {...props}>
    {/* prettier-ignore */}
    <path fillRule="evenodd" clipRule="evenodd" d="M36 0C16.118 0 0 16.118 0 36s16.118 36 36 36 36-16.118 36-36S55.882 0 36 0zm4.142 21.417a4.53 4.53 0 00-4.553-4.554 4.53 4.53 0 00-4.554 4.554 4.53 4.53 0 004.554 4.553 4.53 4.53 0 004.553-4.553zm-.49 34.86V33.452H31.53v22.827h8.123zm24.9-20.279C64.552 20.23 51.769 7.446 36 7.446S7.448 20.23 7.448 35.998 20.231 64.55 36 64.55s28.552-12.783 28.552-28.552z" />
  </CreateIconComponent>
);

export default InfoIcon;
